import VmoBotStyles from "./VmoBot.module.scss";

import { useAppDispatch, useAppSelector } from "../../../../hooks/store";
import comicBubbleSvg from "../../../../assets/comic_bubble.svg";
import bookSparkSvg from "../../../../assets/book_spark.svg";
import refreshChatSvg from "../../../../assets/refreshChat.svg";
import searchSvg from "../../../../assets/search.svg";
import activeSendMessageSvg from "../../../../assets/send_message.svg";
import inActiveSendMessage from "../../../../assets/inactiveSendMessage.svg";
import showLess from "../../../../assets/showLess.svg";
import showAllSvg from "../../../../assets/showAll.svg";
import copyMessageUnselected from "../../../../assets/copyMessageUnselected.svg";
import copyMessageSelected from "../../../../assets/copyMessageSelected.svg";
import fileCopyUnselected from "../../../../assets/file_copy.svg";
import fileCopySelected from "../../../../assets/file_copy_selected.svg";
import thumbsUpUnselected from "../../../../assets/thumb_up.svg";
import thumbsUpSelected from "../../../../assets/thumb_up_selected.svg";
import thumbsDownUnselected from "../../../../assets/thumb_down.svg";
import thumbsDownSelected from "../../../../assets/thumb_down_selected.svg";
import driveSvg from "../../../../assets/images/googleDriveLogo.svg";
import {
  resetVmoBotChatThunk,
  sendMessageToVmoBotThunk,
  sendSuggestionToVmoBotThunk,
  setModalOpen,
  updateVmoBotModel,
  uploadMutliDocFromBotThunk,
} from "../../store/dashboard.thunk";
import { Fragment } from "react/jsx-runtime";
import Input from "../../../../components/Input/Input";
import { useEffect, useRef, useState } from "react";
import BotFileUpload from "../../components/DashboardSelector/BotFileUpload/BotFileUpload";
import { isString } from "underscore";
import RichTextFormatter from "../../../../components/RichTextFormatter/RichTextFormatter";
import {
  copyToClip,
  getToast,
  handleDriveUploadCommonMethod,
} from "../../../../common/utils";
import {
  MIN_MSG_ERROR,
  ttcGeminiModel,
  VMO_BOT_FILE_UPLOAD_LIMIT,
  VMO_BOT_MIN_MSG_LENGTH,
} from "../../constants";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { Tooltip as MUITooltip } from "@mui/material";
import useDrivePicker from "react-google-drive-picker";
import { DASHBOARD_ENTITIES, MimeTypes } from "../../../../common/constants";
import Typography from "../../../../components/Typography/Typography";
import { UploadFileFromDriveBtnTtcChat } from "../../../../components/Buttons/Buttons";
import UploadDoc from "../../../../components/UploadDoc/UploadDoc";

const VmoBot = () => {
  const { vmoBot } = useAppSelector(
    (state) => state.rootReducer.vscDashboardReducer
  );
  const { chat, suggestions, fileUpload, isMessageLoading } = vmoBot;

  const [selectedModel, setSelectedModel] = useState("gemini-2.5-pro"); //gemini-2.5-pro-preview-03-25




  return (
    <div className={VmoBotStyles.vmoBotContentContainer}>
      <VmoBotContent
        chat={chat}
        suggestions={suggestions}
        fileUpload={fileUpload}
        isMessageLoading={isMessageLoading}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
      />
    </div>
  );
};

const VmoBotContent = ({
  chat,
  suggestions,
  fileUpload,
  isMessageLoading,
  selectedModel,
  setSelectedModel,
}: any) => {
  const dispatch = useAppDispatch();
  const { loading, data } = useAppSelector(
    (state) => state.rootReducer.userInfoReducer.profileData
  );
  const { vmoBot } = useAppSelector(
    (store) => store.rootReducer.vscDashboardReducer
  );
  const { processingStage } = vmoBot?.fileUpload;

  const handleModelChange = (e: any) => {
    const { value } = e.target;
    setSelectedModel(value);
    dispatch(
      updateVmoBotModel(
        value === "gemini-2.0-flash"
          ? ttcGeminiModel.GEM_1_5_FLASH_001
          : ttcGeminiModel.GEM_1_5_PRO_001
      )
    );
  };

  const messagesEndRef = useRef<null | HTMLDivElement>(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const shouldRenderSuggestions =
    Array.isArray(suggestions) &&
    suggestions?.length > 0 &&
    !fileUpload?.uploadingState &&
    !isMessageLoading;

  useEffect(() => {
    scrollToBottom();
  }, [chat]);

const [openModal, setOpenModal] = useState<boolean>(false);
useEffect(() => {
  if (vmoBot.openModalState) {
    setOpenModal(vmoBot.open);
  }
}, [vmoBot.openModalState]);

  return (
    <div className={VmoBotStyles.vmoBotContent}>
      <div className={VmoBotStyles.chatContainer}>
        <div className={VmoBotStyles.scrollableSection}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "2px",
            }}
          >
            <div className={VmoBotStyles.helloSection}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div className={VmoBotStyles.helloText}>
                  {/* <img src={bookSparkSvg} alt="" /> */}
                  <span>
                    Hey {loading ? "Guest!" : `${data?.given_name ?? "Guest"}!`}
                  </span>
                  {processingStage === "SelectFiles" && (
                    <Typography
                      color="#00000099"
                      fontSize={14}
                      fontWeight={400}
                    >
                      How can I assist you with contracts today?
                    </Typography>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "space-between",
                    }}
                  >
                    <ToggleButtonGroup
                      color="primary"
                      size="small"
                      value={selectedModel}
                      exclusive
                      onChange={handleModelChange}
                      aria-label="Platform"
                      sx={{
                        border: "1px solid #2E64DE",
                        borderRadius: "20px",
                        "& .MuiToggleButtonGroup-grouped": {
                          borderRadius: "20px",
                          border: "none",
                          "&:not(:first-of-type)": {
                            borderRadius: "20px",
                          },
                          "&:not(:last-of-type)": {
                            borderRadius: "20px",
                          },
                        },
                        padding: "0.225rem",
                      }}
                    >
                      <MUITooltip
                        title={
                          "Accurately extracts data and insights from documents, enabling you to make informed decisions based on reliable information. Perfect for summarizing reports or finding specific data points."
                        }
                        placement="bottom-end"
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "common.black",
                              "& .MuiTooltip-arrow": {
                                color: "common.black",
                              },
                              fontFamily: "Google Sans",
                              fontSize: "12px",
                              fontWeight: 400,
                            },
                          },
                        }}
                      >
                        <div>
                          <ToggleButton
                            value="gemini-2.5-pro"
                            disabled={chat?.length !== 0}
                            style={{
                              padding: "2px",
                              width: "55px",
                              textTransform: "capitalize",
                            }}
                            sx={{ "--ButtonGroup-radius": "40px" }}
                          >
                            Pro
                          </ToggleButton>
                        </div>
                      </MUITooltip>
                      <MUITooltip
                        title={
                          "Prioritizes speed in extracting information, making it ideal for quick overviews. For extremely detailed analysis, a closer look at the original document might still be necessary."
                        }
                        placement="bottom-end"
                        arrow
                        slotProps={{
                          tooltip: {
                            sx: {
                              bgcolor: "common.black",
                              "& .MuiTooltip-arrow": {
                                color: "common.black",
                              },
                              fontFamily: "Google Sans",
                              fontSize: "12px",
                              fontWeight: 400,
                            },
                          },
                        }}
                      >
                        <div>
                          <ToggleButton
                            value="gemini-2.0-flash"
                            disabled={chat?.length !== 0}
                            style={{
                              padding: "2px",
                              width: "48px",
                              textTransform: "capitalize",
                            }}
                          >
                            Flash
                          </ToggleButton>
                        </div>
                      </MUITooltip>
                    </ToggleButtonGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={VmoBotStyles.chatSection}>
            <BotFileUpload />
            {chat?.map((message: any) => {
              return (
                <ChatMessage
                  message={message}
                  isMessageLoading={isMessageLoading}
                  botMessageLoading={message?.loading}
                  errored={message?.errored}
                />
              );
            })}
            {shouldRenderSuggestions && (
              <Suggestions suggestions={suggestions} />
            )}
            {chat.length !== 0 && <div ref={messagesEndRef}></div>}
          </div>
        </div>
        <SendMessageSection
          fileUpload={fileUpload}
          isMessageLoading={isMessageLoading}
          enableNewChat={
            fileUpload?.processedFiles?.length > 0 || chat?.length > 0
          }
        />
         {
          <UploadDoc
            openModal={openModal} 
            setOpenModal={setOpenModal}
            dashboardEntity={DASHBOARD_ENTITIES.TALK_TO_CONTRACT}
          />
        }
      </div>
    </div>
  );
};

const SuggestionPill = ({ suggestion, onClick }: any) => {
  return (
    <div
      className={VmoBotStyles.suggestionPill}
      onClick={() => onClick(suggestion)}
    >
      {suggestion?.text}
    </div>
  );
};

const ShowDataButton = ({ onClick, text, imgSource }: any) => {
  return (
    <div className={VmoBotStyles.showMoreLessBtn} onClick={onClick}>
      <p>{text}</p>
      <img src={imgSource} alt="" />
    </div>
  );
};

const Suggestions = ({ suggestions }: any) => {
  const dispatch = useAppDispatch();
  const [isShowAllClicked, setIsShowAllClicked] = useState(false);
  const handleSuggestionClick = (suggestion: { text: string }) => {
    dispatch(sendSuggestionToVmoBotThunk(suggestion));
  };

  return (
    <div className={VmoBotStyles.suggestionsContainer}>
      <div className={VmoBotStyles.suggestionTitle}>
        <img src={bookSparkSvg} alt="" />
        <span>Suggested Questions</span>
      </div>
      <div className={VmoBotStyles.suggestions}>
        {suggestions?.map((suggestion: any, idx: number) => {
          if (!isShowAllClicked && idx > 2) {
            return (
              <ShowDataButton
                onClick={() => setIsShowAllClicked(true)}
                text="Show More"
                imgSource={showAllSvg}
              />
            );
          }
          return (
            <SuggestionPill
              suggestion={suggestion}
              onClick={handleSuggestionClick}
            />
          );
        })}
        {isShowAllClicked && (
          <ShowDataButton
            onClick={() => setIsShowAllClicked(false)}
            text="Show Less"
            imgSource={showLess}
          />
        )}
      </div>
    </div>
  );
};

const SendMessageSection = ({
  fileUpload,
  isMessageLoading,
  enableNewChat,
}: any) => {
  const dispatch = useAppDispatch();
  const [message, setMessage] = useState("");
  const [canSendMessage, setCanSendMessage] = useState(false);
  const [showMinLenghtError, setShowMinLengthError] = useState(false);

  const { vmoBot } = useAppSelector(
    (store) => store.rootReducer.vscDashboardReducer
  );
  const { processingStage } = vmoBot?.fileUpload;
  const [openPicker] = useDrivePicker();
  const [openingPicker, setOpeningPicker] = useState(false);

  const sendMessage = () => {
    if (canSendMessage) {
      dispatch(sendMessageToVmoBotThunk(message));
      setMessage("");
      setShowMinLengthError(false);
      setCanSendMessage(false);
    }
  };

  const handleOnChange = (val: string) => {
    // Remove spaces, numbers, and non-alphabetic characters
    const filteredMessage = val.replace(/[^a-zA-Z]/g, "");

    if (filteredMessage.length > VMO_BOT_MIN_MSG_LENGTH) {
      setCanSendMessage(true);
      setShowMinLengthError(false);
    } else {
      setCanSendMessage(false);
    }
    setMessage(val);
  };

  const handleEnterPress = ({ key, value }: any) => {
    if (key === "Enter") {
      const filteredMessage = message.replace(/[^a-zA-Z]/g, "");
      if (filteredMessage.length <= VMO_BOT_MIN_MSG_LENGTH) {
        setShowMinLengthError(true);
      }
      sendMessage();
    }
  };

  const handleChatReset = () => {
    setCanSendMessage(false);
    setMessage("");
    dispatch(resetVmoBotChatThunk());
  };

  const handleFileUpload = async () => {
    await handleDriveUploadCommonMethod({
      setLoader: setOpeningPicker,
      openPicker: openPicker,
      multiselect: true,
      mimeTypes: `${MimeTypes.gFile},${MimeTypes.gFolder},${MimeTypes.pdf},${MimeTypes.gDoc}`,
      onResponse: (data: any) => {
        handleCallBackResponse(data);
      },
    });
  };

  const handleCallBackResponse = async (data: {
    action: string;
    docs: any;
  }) => {
    switch (data.action) {
      case "picked":
        const { docs } = data;
        if (docs?.length > VMO_BOT_FILE_UPLOAD_LIMIT) {
          getToast(
            "Error",
            `Cannot upload more than ${VMO_BOT_FILE_UPLOAD_LIMIT} files`
          );
        } else {
          await dispatch(uploadMutliDocFromBotThunk(docs));
        }

        break;

      case "cancel":
      default:
        break;
    }
  };

  return (
    <div className={VmoBotStyles.sendMessageSection}>
      {enableNewChat ? (
        <>
          <Input
            placeholder="Ask question"
            disabled={
              fileUpload?.uploadingState ||
              // isMessageLoading ||
              fileUpload?.processedFiles?.length === 0
            }
            frontImage={searchSvg}
            driveImage={processingStage === "SelectFiles" ? driveSvg : ""}
            driveImgClick={handleFileUpload}
            endImage={
              canSendMessage ? activeSendMessageSvg : inActiveSendMessage
            }
            handlers={{
              onChange: handleOnChange,
              onKeyDown: handleEnterPress,
            }}
            endImageClick={sendMessage}
            inputText={message}
            openingPicker={openingPicker}
            enableNewChat={enableNewChat}
            onNewChatClick={handleChatReset}
          />

          <div className={VmoBotStyles.sendMessageFooter}>
            <p
              style={{
                marginLeft: "16px",
                color: "red",
                visibility: showMinLenghtError ? "visible" : "hidden",
                fontSize: "12px",
              }}
            >
              {MIN_MSG_ERROR}
            </p>
            {/* <div className={VmoBotStyles.chatHistory}>
              <input
                type="checkbox"
                id="history"
                name="history"
                value="Chat History"
              />
              <label htmlFor="history">Chat History</label>
              </div> */}
                  {/* {enableNewChat && (
                <div className={VmoBotStyles.newChat} onClick={handleChatReset}>
                  <img src={refreshChatSvg} alt="" />
                  <span>New Chat</span>
                </div>
              )} */}
          </div>
        </>
      ) : (
        <UploadFileFromDriveBtnTtcChat
          onClick={handleFileUpload}
          loading={openingPicker}
          disabled={openingPicker}
          fullWidth
        />
      )}
    </div>
  );
};

export const ChatMessage = ({
  message,
  isMessageLoading,
  botMessageLoading,
  errored,
}: any) => {
  const { sender, text } = message;
  const isSenderBot = sender === "bot";
  const senderClass = isSenderBot
    ? VmoBotStyles.botMessage
    : VmoBotStyles.userMessage;
  return (
    <div className={senderClass}>
      {isSenderBot ? (
        <BotMessage
          text={text}
          loading={isMessageLoading}
          botMessageLoading={botMessageLoading}
          errored={errored}
        />
      ) : (
        <UserMessage text={text} />
      )}
    </div>
  );
};

const BotMessage = ({ text, loading, botMessageLoading, errored }: any) => {
  const isArray = Array.isArray(text);
  const [isCopied, setIsCopied] = useState(false);
  const [isThumbsUp, setIsThumbsUp] = useState(false);
  const [isThumbsDown, setIsThumbsDown] = useState(false);
  const contentId = `botMessage-${JSON.stringify(text)}`;

  const handleThumbsUp = () => {
    setIsThumbsUp(!isThumbsUp);
    setIsThumbsDown(false);
  };

  const handleThumbsDown = () => {
    setIsThumbsDown(!isThumbsDown);
    setIsThumbsUp(false);
  };

  return (
    <Fragment>
      {/* <VmoBotImg variant="small" /> */}
      <div>
        <img src={bookSparkSvg} alt="" width="24" height="24" />
      </div>
      {botMessageLoading ? (
        <div className={VmoBotStyles.botMessageLoader}>
          {new Array(3).fill("").map((dot, index) => {
            return (
              <div
                className={VmoBotStyles.dot}
                style={{ animationDelay: `${index * 0.7}s` }}
              ></div>
            );
          })}
        </div>
      ) : isArray ? (
        <Fragment>
          {text?.length > 0 ? (
            <div className={VmoBotStyles.messageContainer}>
              <span
                className={VmoBotStyles.messageContainerForBot}
                id={contentId}
              >
                {text?.map(
                  (fileResponse: { [key: string]: string }, idx: number) => {
                    const key = Object.keys(fileResponse)[0];
                    const value = fileResponse?.[key];
                    return (
                      <div>
                        <div style={{ fontWeight: "bold" }}>{key}</div>
                        <RichTextFormatter
                          rawText={value}
                          isUserMessage={false}
                          indent={false}
                        />
                        {text?.length !== idx + 1 && <br />}
                      </div>
                    );
                  }
                )}
              </span>
              <div className={VmoBotStyles.copyIcon}>
                <img
                  src={isCopied ? fileCopySelected : fileCopyUnselected}
                  alt=""
                  height="24px"
                  onClick={() => {
                    const contentElement = document.getElementById(contentId);
                    if (contentElement) {
                      copyToClip({
                        innerHTML: contentElement?.innerHTML,
                        setLoader: setIsCopied,
                      });
                    }
                  }}
                />
                <img
                  height="16"
                  width="16"
                  src={isThumbsUp ? thumbsUpSelected : thumbsUpUnselected}
                  alt=""
                  onClick={handleThumbsUp}
                />
                <img
                  height="16"
                  width="16"
                  src={isThumbsDown ? thumbsDownSelected : thumbsDownUnselected}
                  alt=""
                  onClick={handleThumbsDown}
                />
              </div>
            </div>
          ) : (
            <RichTextFormatter
              rawText="The attached document does not contain information relevant to
              your query."
              isUserMessage={false}
              indent={false}
            />
          )}
        </Fragment>
      ) : (
        isString(text) && (
          <RichTextFormatter
            rawText={text}
            isUserMessage={false}
            indent={false}
          />
        )
      )}
    </Fragment>
  );
};

const UserMessage = ({ text }: any) => {
  return (
    <Fragment>
      <RichTextFormatter rawText={text} isUserMessage={true} />
      {/* <ImageBadgeName /> */}
    </Fragment>
  );
};

export default VmoBot;
